import React from 'react';
import { useParams } from 'react-router';
import { useMutation, useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { message } from 'antd';
import {
  UPDATE_PROPOSAL_REVISION,
  GET_PROPOSAL_REVISION,
} from 'gql/proposalRevisions';
import ProposalRevisionForm from '../../components/ProposalRevisionForm';
import { convertFilesForInitialValues, getId } from 'utils';
import useProjectFrozen from 'hooks/useProjectFrozen';

const EditProposalRevision = ({ reducer: { dispatch } }) => {
  const { projectId, id } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const { data, loading } = useQuery(GET_PROPOSAL_REVISION, {
    variables: {
      ids: [id],
      status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
    },
  });
  const [updateProposalRevision] = useMutation(UPDATE_PROPOSAL_REVISION, {
    refetchQueries: [
      {
        query: GET_PROPOSAL_REVISION,
        variables: {
          ids: [id],
          status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
        },
      },
    ],
    onCompleted: () => {
      message.success(`Proposal Revision saved`);
      dispatch({ type: 'SUBMIT' });
    },
  });
  const initialValues = !data
    ? {}
    : {
        revisedProposal: convertFilesForInitialValues(
          data.proposalRevisions[0].revisedProposal
        ),
        supportingDocuments: convertFilesForInitialValues(
          data.proposalRevisions[0].supportingDocuments
        ),
        changesIncluded: data.proposalRevisions[0].changesIncluded,
        justification: data.proposalRevisions[0].justification,
        highlights: data.proposalRevisions[0].highlights,
      };
  const onFinish = async ({
    revisedProposal,
    highlights,
    justification,
    supportingDocuments,
    changesIncluded,
  }) => {
    await updateProposalRevision({
      variables: {
        input: {
          id,
          projectId,
          revisedProposal: revisedProposal[0].id,
          changesIncluded,
          justification,
          highlights,
          supportingDocuments: getId(supportingDocuments),
        },
      },
    });
  };

  return (
    <PageContainer loading={loading}>
      <ProposalRevisionForm
        onFinish={onFinish}
        initialValues={initialValues}
        disabled={projectFrozen}
      />
    </PageContainer>
  );
};

export default EditProposalRevision;
